import React, { Component } from 'react';
import { Loader } from 'react-loaders';
import { translate } from 'react-i18next';

import Map from 'components/Map/Map';
import Menu from 'components/Menu/Menu';
import Header from 'components/Header/Header';
import CustomModal from 'components/CustomModal/CustomModal';
import Utils from 'utils/Utils';
import {
  initMap, isLoadedMap, mapjs, highlightFeatures, addCustomWMSLayer, addFlightLayers, newGeoJSONLayer,
  removeAllCustomWMSLayer, isCustomWMSLayerActive, removeAllFlightLayers, clearPrintLayer,
} from 'utils/Visor';

import 'loaders.css/loaders.min.css';
import './Layout.css';

declare var CONFIGURATIONS;

class Layout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      menuOpened: false,
      blocking: true,
      loading: true,
      selectedFeatures: [],
      selectedFullFeatures: [],
      flights: [],
      selectedFlight: {},
      allFlights: [],
    };
  }

  componentDidMount() {
    const _this = this;
    _this.setState({ loading: false }, () => {
      initMap(_this.getSelectedFlight, _this.getSelectedFeatures, _this.getSelectedFullFeatures, _this.selectFeatures, _this.unblock, _this.props.t);
    });
  }

  block = () => {
    this.setState({ blocking: true });
  }

  unblock = () => {
    this.setState({ blocking: false });
  }

  updateFlights = (flights) => {
    this.setState({ flights });
  }

  setAllFlights = (flights) => {
    this.setState({ allFlights: flights });
  }

  getSelectedFlight = () => {
    return this.state.selectedFlight;
  }

  getSelectedFeatures = () => {
    return this.state.selectedFeatures;
  }

  getSelectedFullFeatures = () => {
    return this.state.selectedFullFeatures;
  }

  selectFlight = (flight) => {
    clearPrintLayer();
    this.setState({ selectedFlight: flight });
  }

  allFotogramsOpenedSameLayer = () => {
    const _this = this;
    let res = false;
    if (this.state.selectedFeatures.length > 0) {
      let opened = this.state.selectedFullFeatures.filter((f) => {
        const flight = _this.state.flights.filter((flight) => {
          return f.properties.id_vuelo.indexOf(flight.name) > -1;
        })[0];

        if (flight !== undefined) {
          return isCustomWMSLayerActive(f.properties.fotogramas) && _this.state.selectedFlight.id === flight.id;
        } else {
          return false;
        }
      });

      res = res || opened.length > 0;
    } else {
      res = res || true;
    }

    return res;
  }

  selectFeatures = (selectedFeatures, selectedFullFeatures, fromMap) => {
    const _this = this;
    const oldSelected = _this.state.selectedFeatures;
    if (fromMap === true) {
      highlightFeatures(selectedFeatures);
      selectedFeatures.forEach((f) => {
        if (oldSelected.indexOf(f) === -1) {
          _this.block();
          if (!_this.allFotogramsOpenedSameLayer()) {
            removeAllCustomWMSLayer();
          }

          const serviceUrl = _this.state.selectedFlight.resources.filter((r) => r.format.toLowerCase() === 'wms')[0].url;
          addCustomWMSLayer(serviceUrl, f, this.unblock);
        }
      });

      this.setState({ selectedFeatures: selectedFeatures, selectedFullFeatures: selectedFullFeatures }, () => {
        if (!_this.state.menuOpened) {
          _this.openMenuHandler();
        }
      });
    } else {
      highlightFeatures(selectedFeatures);
      this.setState({ selectedFeatures: selectedFeatures, selectedFullFeatures: selectedFullFeatures });
    }
  }

  addCentersLayer = (centersLayer) => {
    this.setState({ centersLayer: centersLayer });
  }

  addMarksLayer = (marksLayer) => {
    this.setState({ marksLayer: marksLayer });
  }

  selectTempFlight = (flightSelected) => {
    const _this = this;
    if (flightSelected !== undefined && this.state.selectedFlight.id !== flightSelected.id) {
      removeAllFlightLayers();
      this.block();
      const coverageFile = flightSelected.resources.filter((r) => r.format.toLowerCase() === 'geojson' && r.name.indexOf('huella_vuelo') > -1)[0].url;
      const centersFile = flightSelected.resources.filter((r) => r.format.toLowerCase() === 'geojson' && r.name.indexOf('centroide_fotogramas') > -1)[0].url;
      const marksFile = flightSelected.resources.filter((r) => r.format.toLowerCase() === 'geojson' && r.name.indexOf('huella_fotogramas') > -1)[0].url;
      Promise.all([Utils.getFile(coverageFile), Utils.getFile(centersFile), Utils.getFile(marksFile)]).then((geojsons) => {
        const coverage = newGeoJSONLayer({ source: geojsons[0], name: CONFIGURATIONS.coverage_name + ' ' + flightSelected.name, extract: false }, { displayInLayerSwitcher: false });
        const centers = newGeoJSONLayer({ source: geojsons[1], name: CONFIGURATIONS.centers_name, extract: false }, { displayInLayerSwitcher: false });
        const marks = newGeoJSONLayer({ source: geojsons[2], name: CONFIGURATIONS.marks_name, extract: false }, { displayInLayerSwitcher: false });
        _this.selectFlight(flightSelected);
        addFlightLayers(coverage, centers, marks, _this.getSelectedFeatures, _this.unblock);
        _this.addCentersLayer(centers);
        _this.addMarksLayer(marks);
      }).catch((err) => {
        _this.unblock();
      });
    } else if (flightSelected === undefined) {
      removeAllFlightLayers();
      _this.selectFlight({});
    }
  }

  openMenuHandler = (evt) => {
    const { menuOpened } = this.state;
    this.setState({ menuOpened: !menuOpened });
    if (isLoadedMap()) {
      setTimeout(() => {
        const center = mapjs.getCenter();
        mapjs.getMapImpl().updateSize();
        setTimeout(() => {
          mapjs.setCenter(center);
          mapjs.refresh();
        }, CONFIGURATIONS.map_loaded_timeout);
      }, CONFIGURATIONS.map_loaded_timeout);
    }
  };

  render() {
    const { menuOpened, selectedFeatures, selectedFullFeatures, centersLayer, flightLayer, flightName, flights, allFlights } = this.state;

    return (
      <div className='content-wrapper'>
        <Header />
        <section className='layout-wrapper'>
          <Menu openMenuHandler={this.openMenuHandler} menuOpened={menuOpened} block={this.block} unblock={this.unblock} flights={flights}
            getSelectedFlight={this.getSelectedFlight} getSelectedFeatures={this.getSelectedFeatures} selectFeatures={this.selectFeatures}
            selectTempFlight={this.selectTempFlight} addMarksLayer={this.addMarksLayer} addCentersLayer={this.addCentersLayer}
            allFotogramsOpenedSameLayer={this.allFotogramsOpenedSameLayer} selectFlight={this.selectFlight} updateFlights={this.updateFlights}
            selectedFeatures={selectedFeatures} centersLayer={centersLayer} flightLayer={flightLayer} flightName={flightName}
            selectedFullFeatures={selectedFullFeatures} setAllFlights={this.setAllFlights} allFlights={allFlights} />
          <Map />
        </section>
        <CustomModal open={this.state.blocking} blocking={true} onClose={this.unblock}>
          <div className='block-loader-container'>
            <Loader active type={'ball-triangle-path'} color='#027335' />
          </div>
        </CustomModal>
      </div>
    );
  }
}

export default translate()(Layout);
